export default "__VITE_ASSET__DbMRysKu__"